<template>
	<Select
		:value="selectedWithUniqueId"
		:placeholder="placeholder"
		:filterable="searchEnable"
		value-key="unique_id"
		@input="updateOption($event)" 
		class="select-default">
		<OptionGroup
			v-for="(group,index) in listWithUniqueId"
			:key="index"
			:label="group.group_type.toString()">
				<div class="ml-5 mt-m20" v-if="group.icon"> <svgicon :name="group.icon" class="icon" width="10" height="10" /> </div>
				<Option
				    class="filter-group-option"
					v-for="item in group.options"
					:key="item.id"
					:label="item.display_label || item.name"
					:value="item">
				</Option>
		</OptionGroup>
	</Select>
</template>

<script>
export default {
	props:{
    category: String,
    placeholder: String,
    search: {
      default: false,
      type: Boolean,
    },
	groupList: Array,
	selected: {},
	searchEnable:{
      default: false,
      type: Boolean,
    },
	},
	computed: {
		selectedWithUniqueId() {
			return Object.assign({}, this.selected,
				{
					unique_id: `${this.selected.id}${this.selected.group_type}`,
				});
		},
		listWithUniqueId() {
			let groupList = this.groupList.map(list => {
				const options = list.options.map(option => {
					return Object.assign({}, option,
						{
							unique_id: `${option.id}${option.group_type}`,
						});
				});
				const listObj = list;
				listObj.options = options;
				return listObj;
			});
			return groupList || [];
		},
	},
	methods: {
		updateOption(option) {
      this.$emit('updateOption', option, this.category);
    },
	},
};
</script>
<style>
	.el-select-dropdown .el-select-group__title {
		background: rgb(238, 242, 244);
		width: 100%;
		font-weight: 800;
		padding: 10px 4px;
    }
	.filter-group-option {
			padding-top: 5px;
	}
</style>
